export default __webpack_public_path__ + "static/media/footer-bg.f2344d19.png";